import React from "react";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { connect } from "react-redux";
import * as userService from "../../state/context/user/services";
import { IconsMap } from "../../components/iconHome/iconhome";
import { Box, Button } from "../../components/ds/SubatomicParticles";
import { H1, H2, P } from "../../components/ds/theme/typography";
import Link from "../../components/ds/atoms/Link";
import Icon from "../../components/ds/atoms/Icon";
import BgViagem from "../../assets/images/bg_viagem.png";
import { ReactComponent as Circle } from "../../assets/svg/circle.svg";
import { ReactComponent as DotsRight } from "../../assets/svg/dots_left.svg";
import { ReactComponent as Dotsleft } from "../../assets/svg/dots_right.svg";
import { ReactComponent as IconHidraulica } from "../../assets/svg/icon_watch.svg";
import { ReactComponent as IconKey } from "../../assets/svg/icon_sign.svg";
import { ReactComponent as IconHealth } from "../../assets/svg/icon_medic.svg";
import { ReactComponent as IconFire } from "../../assets/svg/icon_coffin.svg";
import { ReactComponent as IconNature } from "../../assets/svg/icon_luggage.svg";
import { ReactComponent as IconPipe } from "../../assets/svg/icon_slippin.svg";
import { ReactComponent as IconEletric } from "../../assets/svg/icon_sleep.svg";
import { ReactComponent as IconWash } from "../../assets/svg/icon_crutch.svg";
import { ReactComponent as PesegoCare } from "../../assets/svg/pessego-care.svg";
import InjectImages from "../Images";
import PreImg from "../../components/PreImg";

function Viagem({ history, showModal, user, images }) {
  return (
    <>
      <Box
        gridTemplateColumns="repeat(12,1fr)"
        gridRowGap="1.5rem"
        paddingY={{ mobile: "px", tablet: "0px", desktop: "3rem" }}
        position="relative"
        styling="grid"
      >
        <Box
          alignItems="flex-start"
          gridColumn={{
            mobile: "2/span 10",
            tablet: "2/span 10",
            desktop: "2/span 4",
          }}
          styling="column"
        >
          <H1 styling="base">Nada como um seguro para você curtir sua viagem ao máximo!</H1>
          <Box
            styling="base"
            height="2px"
            width="4vw"
            mt="2rem"
            backgroundColor="primary.default"
          ></Box>
        </Box>

        <Box
          alignItems="flex-start"
          gridColumn={{
            mobile: "2/span 10",
            tablet: "2/span 10",
            desktop: "2/span 4",
          }}
          gridRow="2"
          styling="column"
        >
          <P lineHeight="1.4" textAlign="justify" styling="base">
            Programe sua viagem, escolha seu destino, realize o sonho de
            conhecer lugares novos incríveis e tenha momentos ainda mais
            proveitosos com a tranquilidade de ter a sua cobertura de Seguro
            Viagem contratada aqui na pessego.com. Imprevistos acontecem e a
            pessego.com está preparada para todos eles!
          </P>
        </Box>

        <Box
          gridColumn={{
            mobile: "2/span 10",
            tablet: "2/span 10",
            desktop: "2/span 4",
          }}
          gridRow="3"
          my="2rem"
          styling="column"
        >
          <Button
            onClick={() => {
              history.push({
                pathname: "/form",
                state: { type: "viagem" },
              })
            }}
            styling="primary"
            width="350px"
            height="50px"
          >
            <div style={{ fontSize: 18 }}>Cotar agora seu seguro viagem</div>
          </Button>
          {user && (user.telefone || user.telefoneCelular) && (
            <Button
              my="10px"
              onClick={() => showModal({ visible: true, type: "contact" })}
              styling="primary"
              width="295px"
            >
              Quero falar com alguém, me ligue!
            </Button>
          )}
        </Box>

        <Box
          display={{ mobile: "none", tablet: "none", desktop: "flex" }}
          gridColumn="5/span 8"
          gridRow="2/span 4"
          height="210px"
          mt="150px"
          styling="column"
        >
          <Icon styling="baseNone" height="100%" width="100%">
            <DotsRight width="100%" height="100%" />
          </Icon>
        </Box>

        <Box
          display={{ mobile: "none", tablet: "none", desktop: "flex" }}
          gridColumn="8/span 4"
          gridRow="1/span 4"
          ml="30px"
          styling="column"
        >
          <img alt="" height="100%" src={BgViagem} width="100%" />
        </Box>

        <Box
          display={{ mobile: "none", tablet: "none", desktop: "flex" }}
          gridColumn="7/span 8"
          gridRow="1/span 4"
          position="absolute"
          styling="column"
          top="50px"
        >
          <Circle />
        </Box>

        <Box
          display={{ mobile: "none", tablet: "none", desktop: "flex" }}
          gridColumn="10/span 2"
          gridRow="2/span 4"
          position="absolute"
          styling="column"
          top="145px"
          zIndex="-1"
        >
          <Circle />
        </Box>

        <Box
          alignItems="stretch"
          backgroundColor="pbackground.default"
          borderRadius="12px"
          boxShadow="10px 10px 20px rgba(0,0,0,.05)"
          flexWrap="wrap"
          gridColumn="2/span 10"
          gridRow="4"
          justifyContent="space-between"
          margin={{ mobile: "2rem 0", tablet: "2rem 0", desktop: "0 0 5rem" }}
          position="relative"
          styling="row"
          width="100%"
        >
          <Box
            padding="32px"
            styling="column"
            width={{ mobile: "50%", tablet: "33%", desktop: "25%" }}
          >
            <Box
              backgroundColor="background.default"
              borderRadius="50%"
              height="128px"
              styling="column"
              width="128px"
            >
              <Icon styling="base" height="48px" width="48px">
                <IconHidraulica />
              </Icon>
            </Box>
            <P fontSize="14px" my="15px" styling="bold" textAlign="center">
              Atraso ou cancelamento do vôo
            </P>
          </Box>
          <Box
            padding="32px"
            styling="column"
            width={{ mobile: "50%", tablet: "33%", desktop: "25%" }}
          >
            <Box
              backgroundColor="background.default"
              borderRadius="50%"
              height="128px"
              styling="column"
              width="128px"
            >
              <Icon styling="base" height="48px" width="48px">
                <IconKey />
              </Icon>
            </Box>
            <P fontSize="14px" my="15px" styling="bold" textAlign="center">
              Orientação
            </P>
          </Box>
          <Box
            padding="32px"
            styling="column"
            width={{ mobile: "50%", tablet: "33%", desktop: "25%" }}
          >
            <Box
              backgroundColor="background.default"
              borderRadius="50%"
              height="128px"
              styling="column"
              width="128px"
            >
              <Icon styling="base" height="48px" width="48px">
                <IconHealth />
              </Icon>
            </Box>
            <P fontSize="14px" my="15px" styling="bold" textAlign="center">
              Assistência médica
            </P>
          </Box>
          <Box
            padding="32px"
            styling="column"
            width={{ mobile: "50%", tablet: "33%", desktop: "25%" }}
          >
            <Box
              backgroundColor="background.default"
              borderRadius="50%"
              height="128px"
              styling="column"
              width="128px"
            >
              <Icon styling="base" height="48px" width="48px">
                <IconFire />
              </Icon>
            </Box>
            <P fontSize="14px" my="15px" styling="bold" textAlign="center">
              Morte acidental
            </P>
          </Box>
          <Box
            padding="32px"
            styling="column"
            width={{ mobile: "50%", tablet: "33%", desktop: "25%" }}
          >
            <Box
              backgroundColor="background.default"
              borderRadius="50%"
              height="128px"
              styling="column"
              width="128px"
            >
              <Icon styling="base" height="48px" width="48px">
                <IconNature />
              </Icon>
            </Box>
            <P fontSize="14px" my="15px" styling="bold" textAlign="center">
              Extravio de bagagem
            </P>
          </Box>
          <Box
            padding="32px"
            styling="column"
            width={{ mobile: "50%", tablet: "33%", desktop: "25%" }}
          >
            <Box
              backgroundColor="background.default"
              borderRadius="50%"
              height="128px"
              styling="column"
              width="128px"
            >
              <Icon styling="base" height="48px" width="48px">
                <IconPipe />
              </Icon>
            </Box>
            <P fontSize="14px" my="15px" styling="bold" textAlign="center">
              Acidentes pessoais
            </P>
          </Box>
          <Box
            padding="32px"
            styling="column"
            width={{ mobile: "50%", tablet: "33%", desktop: "25%" }}
          >
            <Box
              backgroundColor="background.default"
              borderRadius="50%"
              height="128px"
              styling="column"
              width="128px"
            >
              <Icon styling="base" height="48px" width="48px">
                <IconEletric />
              </Icon>
            </Box>
            <P fontSize="14px" my="15px" styling="bold" textAlign="center">
              Hospedagem após alta hospitalar
            </P>
          </Box>
          <Box
            padding="32px"
            styling="column"
            width={{ mobile: "50%", tablet: "33%", desktop: "25%" }}
          >
            <Box
              backgroundColor="background.default"
              borderRadius="50%"
              height="128px"
              styling="column"
              width="128px"
            >
              <Icon styling="base" height="48px" width="48px">
                <IconWash />
              </Icon>
            </Box>
            <P fontSize="14px" my="15px" styling="bold" textAlign="center">
              Indenização por invalidez permanente
            </P>
          </Box>
        </Box>

        <Box
          alignItems="flex-start"
          gridColumn="2/span 10"
          gridRow="5"
          styling="column"
        >
          <H2 styling="base">A pessego.com tranquiliza você e cuida da sua viagem.</H2>
        </Box>

        <Box
          alignItems="flex-start"
          gridColumn={{
            mobile: "2/span 10",
            tablet: "2/span 10",
            desktop: "2/span 6",
          }}
          gridRow="6"
          styling="column"
        >
          <P my="2rem" styling="regular">
            Não sabe exatamente o que procura?
          </P>
          <P styling="base">
            Não tem problema! Nossos consultores são especialistas em seguro e
            vão ajudar você a encontrar exatamente o que você precisa e do jeito
            que você preferir: por telefone, e-mail ou chat.
          </P>
          <P my="2rem" styling="regular">
            Preparamos uma lista de dúvidas mais frequentes pra você.
          </P>
          <P display="block" styling="base">
            Aqui está tudo bem explicadinho, mas se preferir conversar com um de
            nossos promotores é só clicar no botão “
            <Link color="primary.default" to="/contato">
              fale conosco
            </Link>
            ”, ok?
          </P>
        </Box>

        <Box
          backgroundColor="pbackground.default"
          display={{ mobile: "none", tablet: "none", desktop: "flex" }}
          borderRadius="50%"
          gridColumn="10/span 2"
          gridRow="6"
          height="256px"
          ml="16px"
          styling="column"
          width="256px"
        >
          {images?.generic1?.url ? (
            <PreImg
              src={images.generic1.url}
              style={{
                width: "120px",
                height: "114px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                styling="row"
                width="80%"
                height="80%"
                borderRadius="4px"
                backgroundColor="#ededed"
              />
            </PreImg>
          ) : (
            <PesegoCare height="120px" width="114px" />
          )}{" "}
        </Box>

        <Box
          alignItems="flex-start"
          gridColumn="1/span 8"
          gridRow="7"
          height="210px"
          my="30px"
          styling="column"
        >
          <Icon styling="baseNone" height="100%" width="70%">
            <Dotsleft width="100%" height="100%" />
          </Icon>
        </Box>

        <Box gridColumn="2/span 10" gridRow="8" styling="column">
          <H2 mb="2rem" styling="base">Outros seguros</H2>
          <Box
            gridGap="1rem"
            gridTemplateColumns={{
              mobile: "repeat(2,1fr)",
              tablet: "repeat(3,1fr)",
              desktop: "repeat(7,1fr)",
            }}
            styling="grid"
            width="100%"
          >
            <IconsMap history={history} />
          </Box>
        </Box>
      </Box>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const mapDispatchToProps = {
  showModal: userService.showModal,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(InjectImages(Viagem));
